$(document).ready(function() {
    $('br').attr('aria-hidden','true');
    $('hr').attr('aria-hidden','true');
    $('a[href="/collections/mother-of-the-bride"].button:contains("View All")').attr('aria-label', 'View all Mother of the Bride collection');
    $('a[href="/collections"].button:contains("Shop All")').attr('aria-label', 'Shop all From Lara collections');
    $('a[href="/collections"].button:contains("Explore all")').attr('aria-label', 'Explore all Our collections');
    $('.swiper-slide.card-slider__slide').removeAttr('role aria-label');

    $('button[data-href="/blogs/news?page=2"].js-btn-load-more').attr('aria-label', 'Load more articles');

    $('.card-text__content a.button.button--outlined.button--uppercase[href="/"]').attr('aria-label', 'Read more about our homepage');


});

// Social and External link warning Fixed with delay
$(document).ready(function() {
    setTimeout(function() {
      const currentHost = window.location.hostname.replace('www.', '');
  
      $('a[href^="http://"], a[href^="https://"]').each(function() {
        const $link = $(this);
        const linkHost = this.hostname.replace('www.', '');
  
        
        if (linkHost === currentHost || !linkHost) return;
  
        const linkText = $link.text().trim() || 'this link';
        const currentAriaLabel = $link.attr('aria-label');
  
        const label = currentAriaLabel 
          ? `${currentAriaLabel} (this link will open in new tab)` 
          : `${linkText} (this link will open in new tab)`;
  
        $link.attr({
          'aria-label': label,
          'title': label,
          'target': '_blank',
          'rel': 'noopener noreferrer'
        });
  
        $link.addClass('external-link');
      });
    }, 2000); 
});


// List of Email aria label assigned
$(document).ready(function() {
    
    $('a[href^="mailto:"]').each(function() {
      
      let email = $(this).attr('href').replace('mailto:', '').trim();
      
      
      if (email) {
        
        email = decodeURIComponent(email)   
                .split('?')[0]              
                .split('&')[0];              
        
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (emailRegex.test(email)) {
          $(this).attr('aria-label', 'Email Address: ' + email);
        } else {
          
          console.warn('Invalid email address:', email);
        }
      }
    });
});

// Label For Phone Numbers
$(document).ready(function() {
    $('a[href^="tel:"]').each(function() {
      const telNumber = $(this).attr('href').replace('tel:', ''); // Remove "tel:" prefix
      const ariaNumber = telNumber.replace(/-/g, '.'); // Replace hyphens with dots
      // Use template literals for proper string interpolation
      $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
    });
});

//Empty Heading issue Fixed
$(document).ready(function() {
  $('h1, h2, h3, h4, h5, h6').each(function() {
    var $heading = $(this);
    if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
      $heading.remove();
    }
  });
});


// Collection filter
$(document).ready(function () {

  const $filterButton = $('#Filters-drawer-button-template--21013065924837__main');
  const $drawer = $('#Filters-menu-drawer-template--21013065924837__main');
  const $closeButton = $drawer.find('button.drawer__button-close');

  let isFilterDrawerOpen = false;

  /* Open drawer */
  $filterButton.on('click keydown', function (e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();

      isFilterDrawerOpen = true;

      $filterButton.attr('aria-expanded', 'true');
      $closeButton.attr('aria-expanded', 'true');

      setTimeout(function () {
        $closeButton.focus();
      }, 500);
    }
  });

  /* Close via close button */
  $closeButton.on('click', function () {
    closeDrawer();
  });

  /* Close via ESC – ONLY when drawer is open */
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && isFilterDrawerOpen) {
      closeDrawer();
    }
  });

  function closeDrawer() {
    isFilterDrawerOpen = false;

    $filterButton.attr('aria-expanded', 'false');
    $closeButton.attr('aria-expanded', 'false');

    setTimeout(function () {
      $filterButton.focus();
    }, 500);
  }

});

// Product page drawer
$(document).ready(function () {

  let $lastTrigger = null;

  const $cartDrawer = $('cart-drawer');
  const $cartCloseBtn = $cartDrawer.find('button.cart-drawer__close[data-drawer-close]');

  /* All elements that open the cart drawer */
  const cartTriggersSelector = `
    button.product-selector__submit[name="add"],
    a#cart-counter[data-cart-link]
  `;

  /* Capture trigger when drawer is opened */
  $(document).on('click keydown', cartTriggersSelector, function (e) {
    if (
      e.type === 'click' ||
      e.key === 'Enter' ||
      e.key === ' '
    ) {
      $lastTrigger = $(this);

      // Wait for drawer to open
      setTimeout(function () {
        if ($cartDrawer.is(':visible')) {
          $cartCloseBtn.attr('tabindex', '0').focus();
        }
      }, 2000);
    }
  });

  /* Observe drawer close (ESC, button, overlay, programmatic) */
  const observer = new MutationObserver(function () {
    if (!$cartDrawer.is(':visible') && $lastTrigger) {
      setTimeout(function () {
        $lastTrigger.focus();
        $lastTrigger = null;
      }, 500);
    }
  });

  observer.observe($cartDrawer[0], {
    attributes: true,
    attributeFilter: ['open', 'class', 'aria-hidden', 'style']
  });

});

// Announcement Bar 
$(document).ready(function () {

  const $announcementSlider = $('announcement-bar-slider');
  const $slides = $announcementSlider.find('.swiper-slide');
  const $wrapper = $announcementSlider.find('.swiper-wrapper');

  /* Update wrapper */
  $wrapper.removeAttr('aria-live');

  /* Update each slide */
  $slides.each(function (index) {
    $(this)
      .attr('role', 'region')
      .attr(
        'aria-label',
        'Store announcement'
      )
      .removeAttr('aria-roledescription');
  });

});

// focus back to skip links
$(document).ready(function () {
  $('.back-to-top').on('click keydown', function (e) {
    // Activate on click, Enter, or Space
    if (
      e.type === 'click' ||
      e.key === 'Enter' ||
      e.key === ' ' ||
      e.keyCode === 13 ||
      e.keyCode === 32
    ) {
      e.preventDefault();

      // Move focus to Skip Links region
      const $skipRegion = $('#back-header');

      if ($skipRegion.length) {
        $skipRegion.attr('tabindex', '-1').focus();
      }
    }
  });
});

// Product DEscription Read More Button
$(document).ready(function () {
  $('.text-truncator__button').each(function () {
    const $button = $(this);

    // Set initial aria-label
    $button.attr('aria-label', 'Read more about product');
    $button.attr('aria-expanded', 'false');

    // Toggle state and label on click
    $button.on('click', function () {
      const isExpanded = $button.attr('aria-expanded') === 'true';

      $button.attr('aria-expanded', !isExpanded);
      $button.attr(
        'aria-label',
        !isExpanded
          ? 'Read less about product'
          : 'Read more about product'
      );
    });
  });
});